module.exports = __webpack_public_path__ + "static/media/Template_28.6db69447.png";